import store from 'src/store';
import dayjs from 'dayjs';
import { selectConfigurationByKeyword, selectModuleConfiguration } from 'src/store/selectors/configurations';
import { selectIsSuperRightsActive, selectUserRightsObject } from 'src/store/selectors/userInfo';
import { ConfKey } from 'src/interfaces/wtsApiV1';
export function mainReportV1AccessCheck() {
    if (selectIsSuperRightsActive(store.getState()))
        return true;
    const moduleConfig = selectModuleConfiguration(store.getState(), 'MainReport');
    const showOldConf = selectConfigurationByKeyword(store.getState())(ConfKey.MainReportShowOld);
    const userGroupId = selectUserRightsObject(store.getState())?.Id;
    if (!moduleConfig)
        return false;
    if (showOldConf?.KeyValueInt === userGroupId)
        return true;
    const { StartNewMainReportMonth, ShowOldMainReport: showAfterMigration } = moduleConfig;
    const newReportMigrationMonth = StartNewMainReportMonth ? dayjs(StartNewMainReportMonth) : null;
    const now = dayjs();
    if (!newReportMigrationMonth || now.isBefore(newReportMigrationMonth))
        return true;
    if (showOldConf?.KeyValueInt === userGroupId)
        return true;
    return now.isAfter(newReportMigrationMonth) && showAfterMigration;
}
export function mainReportV2AccessCheck() {
    if (selectIsSuperRightsActive(store.getState()))
        return true;
    const moduleConfig = selectModuleConfiguration(store.getState(), 'MainReport');
    if (!moduleConfig)
        return false;
    const { StartNewMainReportMonth, ShowNewMainReport: showBeforeMigration } = moduleConfig;
    const newReportMigrationMonth = StartNewMainReportMonth ? dayjs(StartNewMainReportMonth) : null;
    const now = dayjs();
    if (newReportMigrationMonth && now.isAfter(newReportMigrationMonth))
        return true;
    return now.isBefore(newReportMigrationMonth) && showBeforeMigration;
}
export function plannerPolicyAccessCheck() {
    if (selectIsSuperRightsActive(store.getState()))
        return true;
    const showPlannerPolicyConf = selectConfigurationByKeyword(store.getState())(ConfKey.PlannerPolicy);
    return !!showPlannerPolicyConf?.KeyValueBoolean;
}
export function plannerAccessCheck({ isNew }) {
    if (selectIsSuperRightsActive(store.getState()))
        return true;
    const showAdvancedPlannerConf = selectConfigurationByKeyword(store.getState())(ConfKey.AdvancedPlannerEnabled);
    const newIsEnabled = !!showAdvancedPlannerConf?.KeyValueBoolean;
    return isNew
        ? newIsEnabled
        : !newIsEnabled;
}
